import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useActiveSceneImageTrackingData } from "@/utils";
import React from "react";
import { useSelector } from "react-redux";
import Plane from "../../Plane/Plane";
import { ITargetImageReferenceObject } from "../../r3f-components/component-data-structure/types/targetImageReferenceObject";
import EntitySuspenseBoundary from "../../r3f-components/components/boundaries/EntitySuspense";
import map from './map.svg';
import TrackingCurvedReferenceObject from "./TrackingCurvedReferenceObject/TrackingCurvedReferenceObject";
import TrkImage from "./TrackingImage/TrackingImage";
import TrackingRearView from "./TrackingRearView/TrackingRearView";
const ImageTrackingPlaceholder = () => {
    const imageTracking = useActiveSceneImageTrackingData();
    const referenceObject = useSelector((state) => state.contentReducer.contentDoc.targetImageReferenceObject?.referenceObject);
    const targetAreaAspectRatio = useActiveSceneImageTrackingData()?.aspectRatio || 1 / 1.41;
    if (typeof imageTracking !== 'undefined' && imageTracking.scale && imageTracking.filestoreId) {
        const { scale } = imageTracking;
        const opacity = imageTracking?.opacity;
        const trkScale = scale ? [scale[0] * 4, scale[1] * 4, 0] : [4, 4, 0];
        return (_jsx(EntitySuspenseBoundary, { scale: trkScale, rotation: [0, 0, 0], position: [0, 0, 0], renderOrder: -1, children: _jsxs(_Fragment, { children: [typeof referenceObject !== 'undefined' && referenceObject !== ITargetImageReferenceObject.none && _jsx(TrackingCurvedReferenceObject, {}, `${referenceObject}${imageTracking.topRadius}`), _jsx(TrkImage, { opacity: opacity, referenceObject: referenceObject })] }) }));
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsx(Plane, { name: "Tracking Display", enabled: false, visible: true, color: [255, 255, 255, 1], position: [0, 0, -0.011], rotation: [0, 0, 0], scale: [targetAreaAspectRatio * 2, 2, 0], renderOrder: 0, map: map }), _jsx(TrackingRearView, { scale: [targetAreaAspectRatio * 2, 2, 0] })] }));
    }
};
export default React.memo(ImageTrackingPlaceholder);
